import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue' 
import Index from '../views/Index.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '路上畅听--一个专听国际书籍的APP,珠海动听科技有限公司',
      content:{
        keywords:'车载FM,最畅销书籍TOP100,回声阅读,路上畅听FM,广播电台,一路听书,名人演讲,听演讲学英文,高清音频电台,儿童故事,微图书,free book,reading on the way',
        description:'路上畅听是一款现代化的移动学习产品，开小车、坐地铁、搭公交，一路听书是最好的选择，让用户的无聊碎片的时间变成力量与财富，来自最畅销书籍TOP100的有声书，15分钟读尽好书精华。横跨商业、科技、哲学、文史等优质内容，增长你的知识与技能，音频可听文字可视，任君挑选。',
      }
    }
  },
  {
    path: '/Index',
    name: 'Index',
    component: Index, 
  },
  {
    path: '/home',
    name: 'Home',
    component: Home, 
  },
  {
    path:'/library',
    name:'Library',
    component:() => import('../views/Library.vue')
  },
  {
    path:'/authorware-more',
    name:'Library',
    component:() => import('../views/Library.vue')
  },
  {
    path:'/booklist',
    name:'BookList',
    component:() => import('../views/BookList.vue')
  },
  {
    path:'/bookdetail',
    name:'BookDetail',
    component:() => import('../views/BookDetail.vue')
  },
  {
    path:'/authorware-detail',//兼容旧SEO收录
    name:'BookDetail',
    component:() => import('../views/BookDetail.vue')
  },
  {
    path:'/freevip',
    name:'FreeVip',
    component:() => import('../views/FreeVip.vue')
  },
  {
    path:'/downloadapp',
    name:'DownloadApp',
    component:() => import('../views/DownloadApp.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path:'/usercenter',
    name:'UserCenter',
    component:() => import('../views/UserCenter.vue')
  },
  {
    path:'/search',
    name:'/Search',
    component:() => import('../views/Search.vue')
  },
  {
    path:'/anchorinfo',
    name:'/Anchorinfo',
    component:() => import('../views/Anchorinfo.vue')
  },
  {
    path:'/news',
    name:'/News',
    component:() => import('../views/News.vue')
  },
  {
    path:'/newsdetail',
    name:'/NewsDetail',
    component:() => import('../views/NewsDetail.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
